import { NavigationPathsEnum, stackEnum } from "@utilities/enums";
import { useLogout, useNavigation, useOrganisation, useUser } from "@utilities/hooks";
import { useCallback, useEffect, useMemo, useState } from "react";

export type NavItemType = {
    label: string
    stack: stackEnum
    path: NavigationPathsEnum
    icon: string
    disabled: boolean
    isHide: boolean
}

export const useController = () => {

    const { user, isUserInfosIsComplete } = useUser();
    const { organisation, isOrganisationInfosIsComplete, isUserAdmin } = useOrganisation();
    const { onLogout } = useLogout();
    const { navigateTo } = useNavigation();

    const [showLogout, setShowLogout] = useState<boolean>(false);
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

    const isAdvancedFeaturesDisabled = useMemo(() =>(
        !isUserInfosIsComplete || !isOrganisationInfosIsComplete 
    ), [isOrganisationInfosIsComplete, isUserInfosIsComplete]);

    const navItems:NavItemType[] = useMemo(() => [
        {
            label: 'Dashboard',
            stack: stackEnum.dashboardStack,
            path: NavigationPathsEnum.DASHBOARD,
            icon: "ChartLine",
            disabled: isAdvancedFeaturesDisabled,
            isHide: !isUserAdmin,
        },
        {
            label: 'Boutique',
            stack: stackEnum.shopStack,
            path: NavigationPathsEnum.SHOP,
            icon: "Store",
            disabled: isAdvancedFeaturesDisabled,
            isHide: false,
        },
        {
            label: 'Stocks',
            stack: stackEnum.stocksStack,
            path: NavigationPathsEnum.STOCKS,
            icon: "Package",
            disabled: isAdvancedFeaturesDisabled,
            isHide: false,
        },
        {
            label: 'Paramètres',
            stack: stackEnum.settingsStack,
            path: NavigationPathsEnum.SETTINGS,
            icon: "Cog",
            disabled: isAdvancedFeaturesDisabled,
            isHide: false,
        },
    ], [isAdvancedFeaturesDisabled, isUserAdmin]);

    useEffect(()=> {
        if(!user && !organisation){
            navigateTo(NavigationPathsEnum.LOGIN);
        }
        if(isUserInfosIsComplete && !isOrganisationInfosIsComplete){
            navigateTo(NavigationPathsEnum.SETTINGS_MY_ORGANISATION);
        }
        if(!isUserInfosIsComplete && isOrganisationInfosIsComplete){
            navigateTo(NavigationPathsEnum.SETTINGS_MY_ACCOUNT);
        }
        if(!isUserInfosIsComplete && !isOrganisationInfosIsComplete){
            navigateTo(NavigationPathsEnum.SETTINGS_MY_ORGANISATION);
        }
    }, [
        user, organisation, isUserInfosIsComplete, 
        isOrganisationInfosIsComplete
    ]);

    const onToggleMenu = useCallback(() => {
        setIsMenuOpen(e => !e);
    }, []);

    const onToggleLogout = useCallback(() => {
        setShowLogout(e => !e);
    }, [setShowLogout]);

    const onNavigateTo = useCallback((navItem: NavItemType) => {
        if (!navItem.disabled) {
            navigateTo(navItem.path);
        }
    }, [navigateTo]);

    const onHandleLogout = useCallback(() => {
        onLogout();
        navigateTo(NavigationPathsEnum.LOGIN);
    }, [navigateTo, onLogout]);

    return {
        user,
        organisation,
        navItems,
        showLogout,
        isMenuOpen,
        onToggleMenu,
        onNavigateTo,
        onToggleLogout,
        onHandleLogout,
    }
}
